import styled from 'styled-components';

export const SearchContainer = styled.div`
  .ant-input-affix-wrapper {
    height: 62px;
    width: 295px;
    border-radius: 0px !important;
    font-family: Sofia Pro;
    font-size: 20px !important;
    letter-spacing: 1.1px;

    .ant-input-prefix {
      position: absolute;
      right: 10px;
      top: 20px;
      z-index: 9;
    }

    input::placeholder {
      color: var(--neutral-4);
      font-family: var(--font-family);
      font-size: 20px;
      font-weight: 500;
      letter-spacing: 0;
      padding: 5px 0 0 0;
      margin: 0 0 -10px 0;
      white-space: pre-wrap;
      width: 100%;
    }
    input {
      color: var(--neutral-5);
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      line-height: 28px;
      font-size: 18px;
      padding: 0 10px;
    }
  }

  .ant-input-affix-wrapper.filled {
    .ant-input-prefix {
      display: none;
    }
  }

  @media (max-width: 768px) {
    .ant-input-affix-wrapper {
      width: 100%;
    }
  }
`;
